// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"zo-z","slideIn":"Ao-z"};